var _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _g2, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _g3, _g4, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIllustrationinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 239,
    height: 211,
    viewBox: "0 0 239 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration_inline_svg__filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.783,
    y: 5.457,
    width: 100,
    height: 150,
    rx: 1.5,
    transform: "rotate(10 134.783 5.457)",
    fill: "#fff"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 142.029,
    y: 21.967,
    width: 60,
    height: 5,
    rx: 2.5,
    transform: "rotate(10 142.029 21.967)",
    fill: "#F1F1F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 140.291,
    y: 31.814,
    width: 70,
    height: 5,
    rx: 2.5,
    transform: "rotate(10 140.291 31.814)",
    fill: "#F1F1F9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 138.553,
    y: 41.662,
    width: 80,
    height: 5,
    rx: 2.5,
    transform: "rotate(10 138.553 41.662)",
    fill: "#F1F1F9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 135.949,
    y: 56.434,
    width: 80,
    height: 30,
    rx: 2,
    transform: "rotate(10 135.949 56.434)",
    fill: "#F1F1F9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 129.871,
    y: 90.902,
    width: 30,
    height: 30,
    rx: 2,
    transform: "rotate(10 129.871 90.902)",
    fill: "#F1F1F9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 164.34,
    y: 96.981,
    width: 45,
    height: 30,
    rx: 2,
    transform: "rotate(10 164.34 96.98)",
    fill: "#F1F1F9"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration_inline_svg__filter1_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 23.365,
    width: 100,
    height: 150,
    rx: 1.5,
    transform: "rotate(-10 5 23.365)",
    fill: "#fff"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 17.453,
    y: 36.4,
    width: 37,
    height: 30,
    rx: 2,
    transform: "rotate(-10 17.453 36.4)",
    fill: "#F1F1F9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 58.815,
    y: 29.107,
    width: 38,
    height: 30,
    rx: 2,
    transform: "rotate(-10 58.815 29.107)",
    fill: "#F1F1F9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 25.268,
    y: 80.717,
    width: 60,
    height: 5,
    rx: 2.5,
    transform: "rotate(-10 25.268 80.717)",
    fill: "#F1F1F9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 27.004,
    y: 90.564,
    width: 70,
    height: 5,
    rx: 2.5,
    transform: "rotate(-10 27.004 90.564)",
    fill: "#F1F1F9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 28.74,
    y: 100.414,
    width: 80,
    height: 5,
    rx: 2.5,
    transform: "rotate(-10 28.74 100.414)",
    fill: "#F1F1F9"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 30.477,
    y: 110.262,
    width: 60,
    height: 5,
    rx: 2.5,
    transform: "rotate(-10 30.477 110.262)",
    fill: "#F1F1F9"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 32.213,
    y: 120.109,
    width: 70,
    height: 5,
    rx: 2.5,
    transform: "rotate(-10 32.213 120.109)",
    fill: "#F1F1F9"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 33.949,
    y: 129.959,
    width: 80,
    height: 5,
    rx: 2.5,
    transform: "rotate(-10 33.95 129.959)",
    fill: "#F1F1F9"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 37.422,
    y: 149.654,
    width: 80,
    height: 5,
    rx: 2.5,
    transform: "rotate(-10 37.422 149.654)",
    fill: "#F1F1F9"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 35.685,
    y: 139.807,
    width: 60,
    height: 5,
    rx: 2.5,
    transform: "rotate(-10 35.685 139.807)",
    fill: "#F1F1F9"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration_inline_svg__filter2_ddd)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration_inline_svg__filter3_i)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 21,
    width: 100,
    height: 150,
    rx: 1.5,
    fill: "#9797FF"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "illustration_inline_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 69,
    y: 21,
    width: 100,
    height: 150
  }, /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 21,
    width: 100,
    height: 150,
    rx: 1.5,
    fill: "#9797FF"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#illustration_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.679,
    cy: 84.75,
    rx: 37.736,
    ry: 37.5,
    fill: "#A0C4FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.679,
    cy: 84.75,
    rx: 28.302,
    ry: 28.125,
    fill: "#B3CFFF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration_inline_svg__filter4_di)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.282 138v-30h-30.188v30h21.563v-12.857h-8.625v-4.286h8.625v-4.286h-12.938v12.858h8.625v4.285h-12.938v-21.428h21.564V138h4.312z",
    fill: "url(#illustration_inline_svg__paint0_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    fill: "#0F0449"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.822 156.074v-6.75h2.641c.764 0 1.367.216 1.81.646.444.425.665.987.665 1.688v.019c0 .759-.246 1.344-.739 1.755-.492.412-1.117.617-1.874.617h-1.081v2.025h-1.422zm1.422-3.346h1.127c.345 0 .619-.096.822-.289a.968.968 0 00.305-.733v-.019c0-.328-.102-.579-.305-.752-.203-.18-.486-.27-.85-.27h-1.099v2.063zM116.268 156.074v-6.75h2.521c1.003 0 1.825.322 2.465.965.647.636.97 1.433.97 2.391v.019c0 .965-.323 1.768-.97 2.411-.64.643-1.462.964-2.465.964h-2.521zm2.521-5.409h-1.099v4.069h1.099c.578 0 1.046-.187 1.403-.559.364-.373.545-.859.545-1.456v-.02c0-.598-.181-1.086-.545-1.465-.357-.38-.825-.569-1.403-.569zM123.768 156.074v-6.75h4.922v1.35h-3.5v1.437h3.085v1.35h-3.085v2.613h-1.422z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration_inline_svg__paint1_linear)",
    fillOpacity: 0.29,
    d: "M73.527 21h4.906v150h-4.906z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 168.999,
    cy: 21,
    rx: 75.472,
    ry: 75,
    fill: "#9EC3FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.001,
    cy: 21,
    rx: 66.038,
    ry: 65.625,
    fill: "#B3CFFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 169,
    cy: 21,
    rx: 56.604,
    ry: 56.25,
    fill: "#C7DCFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 169,
    cy: 21,
    rx: 47.17,
    ry: 46.875,
    fill: "#D6E6FF"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration_inline_svg__filter5_ddd)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 169.001,
    cy: 161.001,
    r: 20.833,
    fill: "#0C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.001 153v16m0 0l7.999-6.4m-7.999 6.4L161 162.6",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194 161c0 13.807-11.193 25-25 25s-25-11.193-25-25 11.193-25 25-25 25 11.193 25 25zm-25 20.833c11.506 0 20.833-9.327 20.833-20.833 0-11.506-9.327-20.833-20.833-20.833-11.506 0-20.833 9.327-20.833 20.833 0 11.506 9.327 20.833 20.833 20.833z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "illustration_inline_svg__filter0_d",
    x: 103.973,
    y: 0.695,
    width: 134.053,
    height: 174.611,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0313726 0 0 0 0 0.109804 0 0 0 0 0.270588 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration_inline_svg__filter1_d",
    x: 0.238,
    y: 1.238,
    width: 134.053,
    height: 174.611,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0313726 0 0 0 0 0.109804 0 0 0 0 0.270588 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration_inline_svg__filter2_ddd",
    x: 49,
    y: 6,
    width: 140,
    height: 190,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0313726 0 0 0 0 0.109804 0 0 0 0 0.270588 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0313726 0 0 0 0 0.109804 0 0 0 0 0.270588 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0313726 0 0 0 0 0.109804 0 0 0 0 0.270588 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow",
    result: "effect3_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect3_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration_inline_svg__filter3_i",
    x: 69,
    y: 21,
    width: 100,
    height: 150,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration_inline_svg__filter4_di",
    x: 103.344,
    y: 107.625,
    width: 31.689,
    height: 31.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.563
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0156863 0 0 0 0 0.286275 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect2_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration_inline_svg__filter5_ddd",
    x: 124,
    y: 121,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0313726 0 0 0 0 0.109804 0 0 0 0 0.270588 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0313726 0 0 0 0 0.109804 0 0 0 0 0.270588 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0313726 0 0 0 0 0.109804 0 0 0 0 0.270588 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow",
    result: "effect3_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect3_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration_inline_svg__paint0_linear",
    x1: 135.415,
    y1: 108,
    x2: 104.283,
    y2: 138.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDBF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration_inline_svg__paint1_linear",
    x1: 73.527,
    y1: 97.555,
    x2: 79.376,
    y2: 97.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#1A1D37",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopOpacity: 0
  })))));
}

export default SvgIllustrationinline;